import React,{useState,useEffect} from 'react'
import {Avatar, Button, Menu, Typography} from 'antd'
import {Link} from 'react-router-dom'
import {HomeOutlined, MoneyCollectOutlined, BulbOutlined, FundOutlined, MenuOutlined} from '@ant-design/icons'
import icon from '../images/CryptoLogo.png'

const Navabr = () => {

    const [activeMenu, setActiveMenu] = useState(true);
    const [windowWidth, setwindowWidth] = useState(null);
    
    useEffect(() =>{
        const handleResize = () =>setwindowWidth(window.innerWidth)

        window.addEventListener('resize', handleResize)
        handleResize()

        return () => window.removeEventListener('resize', handleResize)
    },[])

    useEffect(() =>{
        if(windowWidth < 786){
            setActiveMenu(false)
        }else {
            setActiveMenu(true)
        }
    }, [windowWidth])
    return (
        <div className="nav-container">
            <div className="logo-container">
                <Avatar src={icon} size='large'/>
                <Typography.Title level={2} className="logo">
                <Link to='/'>CryptoVerse</Link>
                </Typography.Title>

                <Button className="menu-control-container" onClick={() => setActiveMenu(!activeMenu)}><MenuOutlined /></Button>
            
            </div>
            {activeMenu && (
                <Menu theme="dark">
                    <Menu.Item icon={<HomeOutlined />}>
                        <Link to='/'>Home</Link>
                    </Menu.Item>
                    <Menu.Item icon={<FundOutlined />}>
                        <Link to='/cryptocurrencies'>Crypto Currencies</Link>
                    </Menu.Item>
                    <Menu.Item icon={<MoneyCollectOutlined />}>
                        <Link to='/exchanges'>Exchanges</Link>
                    </Menu.Item>
                    <Menu.Item icon={<BulbOutlined />}>
                        <Link to='/news'>News</Link>
                    </Menu.Item>
                </Menu>
            )}
        </div>
    )
}

export default Navabr
